import { ContentfulSupportArticle } from '@jbhi-fi/apis/src/contentful/types';
import { CategoryPageData } from '@jbhi-fi/components/src/hooks/useContentfulHelpAndSupport/useContentfulHelpAndSupport';
import { BreadcrumbItemProps } from '@jbhi-fi/components/src/SimpleBreadcrumbs/SimpleBreadcrumbs';

export const getBreadCrumbs = (
  articlePage: ContentfulSupportArticle | undefined,
  categoryPage: CategoryPageData | undefined,
  handle: string
): Array<BreadcrumbItemProps> => {
  const breadcrumbs: Array<BreadcrumbItemProps> = [{ label: 'Help & Support', href: '/' }];

  if (handle === 'search') {
    breadcrumbs.push({ label: 'Search results' });
    return breadcrumbs;
  }

  const collectParentCrumbs = (
    startParent: CategoryPageData['subCategories'][number] | undefined,
    maxDepth = 5
  ): Array<BreadcrumbItemProps> => {
    const helper = (
      node: CategoryPageData['subCategories'][number] | undefined,
      depthLeft: number,
      seen: Set<unknown>
    ): Array<BreadcrumbItemProps> => {
      if (!node || depthLeft <= 0 || seen.has(node)) return [];

      seen.add(node);
      const { heading, urlSlug, parentCategory } = node.fields ?? {};
      const current: BreadcrumbItemProps = {
        label: heading || '',
        href: `/${urlSlug}`,
      };

      return [...helper(parentCategory, depthLeft - 1, seen), current];
    };

    return helper(startParent, maxDepth, new Set());
  };
  if (categoryPage) {
    const parent = categoryPage.subCategories?.[0]?.fields?.parentCategory;

    const parentCrumbs = collectParentCrumbs(parent);
    breadcrumbs.push(...parentCrumbs);

    if (parentCrumbs.length === 0 || parentCrumbs[parentCrumbs.length - 1].label !== categoryPage.title) {
      breadcrumbs.push({ label: categoryPage.title });
    }

    return breadcrumbs;
  }

  if (articlePage) {
    const parentCrumbs = collectParentCrumbs(articlePage.fields?.supportCategory);
    breadcrumbs.push(...parentCrumbs);

    breadcrumbs.push({
      label: articlePage.fields?.heading || '',
      href: `/${articlePage.fields?.urlSlug}`,
    });
  }

  return breadcrumbs;
};
